import { ca } from '@cian/analytics';
import { INFRASTRUCTURE_TYPE_LABEL } from './constants';

export const trackInfrastructureMapShow = () => {
  ca('teaser', {
    product: {
      name: 'infrastructure',
    },
  });
};

export const trackInfrastructureMapExist = () => {
  ca('teaser', {
    product: {
      name: 'infrastructure_exist',
    },
  });
};

export const trackFullscreenClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Open_sopr',
    label: 'Map',
  });
};

export const trackInfrastructureTypeClick = (type: string) => {
  // @ts-ignore
  const label = INFRASTRUCTURE_TYPE_LABEL[type];

  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_sopr',
    label,
  });
};

export const trackMapPinClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_sopr',
    label: 'MapPin',
  });
};

export const trackZoomControlClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_sopr',
    label: 'MapChangeScale',
  });
};

export const trackRouteButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_sopr',
    label: 'MapRoute',
  });
};

export const trackRouteSuccess = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Fill_sopr',
    label: 'MapAddress',
  });
};
